import { KeyRound, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { scrollToId } from "../lib/scroll";

export const Ownership = () => (
  <section id="il-sito-rimane-tuo" aria-labelledby="ownership-title" className="bg-mist">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal>
        <div className="relative overflow-hidden rounded-2xl border border-navy/10 bg-navy-dark px-7 py-12 text-white shadow-2xl shadow-navy/20 sm:px-12 sm:py-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-celeste/15 blur-[90px]"
          />
          <div className="relative grid gap-10 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-8">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-celeste/15 text-celeste" aria-hidden="true">
                <KeyRound className="h-6 w-6" />
              </span>
              <h2 id="ownership-title" className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                Il sito rimane tuo.
              </h2>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
                Al termine del progetto ricevi gli accessi necessari alla gestione del tuo sito e
                della relativa infrastruttura. Non sei obbligato a rimanere legato a DS LAB STUDIO.
              </p>
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/60 sm:text-base">
                Potrai continuare a gestire il sito autonomamente oppure affidarlo in futuro a un
                altro professionista. Se invece vorrai continuare con noi, potremo occuparci di
                aggiornamenti, modifiche e gestione.
              </p>
              <p className="mt-6 max-w-2xl border-l-2 border-celeste/60 pl-4 text-xs leading-relaxed text-white/50 sm:text-sm">
                Dominio, hosting ed eventuali servizi esterni necessari al funzionamento del sito
                sono intestati e sostenuti direttamente dal cliente. DS LAB STUDIO può occuparsi
                della configurazione tecnica iniziale.
              </p>
            </div>
            <div className="lg:col-span-4 lg:justify-self-end">
              <a
                href="#contatti"
                onClick={(e) => { e.preventDefault(); scrollToId("#contatti"); }}
                data-testid="ownership-cta"
                className="group inline-flex items-center gap-2 rounded-lg bg-white px-7 py-3.5 text-base font-semibold text-navy-dark transition-all duration-200 hover:bg-celeste-soft active:scale-[0.98]"
              >
                Parlaci del tuo progetto
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
